import getLikertLabels from "./getLikertLabels";

const likertValues = {
  likert_csat: [
    { value: 1, label: "extremely_unsatistied" },
    { value: 2, label: "unsatisfied" },
    { value: 3, label: "neutral" },
    { value: 4, label: "satisfied" },
    { value: 5, label: "extremely_satistied" }
  ],
  likert_5: [
    { value: 1, label: "strongly_disagree" },
    { value: 2, label: "disagree" },
    { value: 3, label: "neutral" },
    { value: 4, label: "agree" },
    { value: 5, label: "strongly_agree" }
  ],
  likert_7: [
    { value: 1, label: "strongly_disagree" },
    { value: 2, label: "disagree" },
    { value: 3, label: "somewhat_disagree" },
    { value: 4, label: "neutral" },
    { value: 5, label: "somewhat_agree" },
    { value: 6, label: "agree" },
    { value: 7, label: "strongly_agree" }
  ]
};

/**
 * Get scale array based on likert questions
 * @param {the question type(CES of CSAT)} questionType
 * @param {max_scale} maxScale
 */
export default function getLikertScale(questionType, maxScale, language) {
  let likertScale = [];
  if (questionType === 1 || questionType === 12) {
    if (maxScale === 7) {
      likertScale = [...likertValues.likert_7];
    } else {
      likertScale = [...likertValues.likert_5];
    }
  } else {
    likertScale = [...likertValues.likert_csat];
  }

  return getLikertLabels(likertScale, language);
}
